import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/developer/sftp/dashboard")({
    beforeLoad: ({ search }) => {
        throw redirect({ to: "/developer/sftp/diaries", search, replace: true });
    },
});
